import React from "react";
import Sidebar from "../../components/Layout/Sidebar";
import Header from "../../components/Layout/Header";
import { useTheme } from "../../contexts/ThemeContext";
import { Sun, Moon, Laptop } from "lucide-react";

import "../../assets/styles/user-settings.css";

const THEME_OPTIONS = [
  { value: "light" as const, label: "Light", icon: Sun },
  { value: "dark" as const, label: "Dark", icon: Moon },
  { value: "auto" as const, label: "Auto", icon: Laptop },
];

const UserSettingsPage: React.FC = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="app-container">
      <Sidebar />

      <div className="main">
        <Header />

        <div className="content">
          <div className="settings-page-header">
            <h2>Settings</h2>
            <p>Manage your appearance preferences.</p>
          </div>

          <div className="settings-card">
            <div className="settings-card-header">
              <h3>Appearance</h3>
              <p>Choose how the application looks on this device.</p>
            </div>

            <div className="theme-option-group">
              {THEME_OPTIONS.map(({ value, label, icon: Icon }) => (
                <button
                  key={value}
                  type="button"
                  className={`theme-option${theme === value ? " active" : ""}`}
                  onClick={() => setTheme(value)}
                >
                  <Icon size={18} />
                  <span>{label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettingsPage;
